import { Avatar, Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React, { useEffect, useState } from 'react'
import { Bar, Doughnut } from 'react-chartjs-2'
import Doughnutdata from '../../chartsData/Doughnutdata'
import CardWithChart from '../../components/CardWithChart'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { generateRandomColor } from '../../shared/constants'
const useStyles = makeStyles((theme) => ({
  root: {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}))
export default function AuditDashboard() {
  const classes = useStyles()
  const [dashboardData, setDashboardData] = useState({
    loading: false,
    allData: false,
  })

  const dashboardStats = dashboardData && dashboardData.allData

  console.log(dashboardStats)
  const { GET_ALL_DATA } = useRestApi()

  const getDashboardData = () => {
    GET_ALL_DATA({}, 'GET_AUDIT_DASHBOARD', setDashboardData, dashboardData)
  }

  useEffect(() => {
    getDashboardData()
  }, [])

  const options = {
    legend: {
      display: true,
      position: 'bottom',
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  }
  const dougnutData = () => {
    // return []
    if (dashboardStats && dashboardStats.averageCount && dashboardStats.averageCount.length) {
      console.log('Got it')
      return {
        labels: dashboardStats.averageCount && dashboardStats.averageCount.map((item) => item.status),
        datasets: [
          {
            label: 'Task',
            data: dashboardStats.averageCount && dashboardStats.averageCount.map((item) => item.count),
            backgroundColor: generateRandomColor(dashboardStats.averageCount),
            hoverOffset: 4,
          },
        ],
      }
    } else {
      return []
    }
    // if (!dashboardData.loading && dashboardData.allData.length > 0) {
    //   return {
    //     labels: dashboardStats.averageCount && dashboardStats.averageCount.map((item) => item.status),
    //     datasets: [
    //       {
    //         label: 'Task',
    //         data: dashboardStats.averageCount && dashboardStats.averageCount.map((item) => item.count),
    //         backgroundColor: generateRandomColor(dashboardStats.averageCount),
    //         hoverOffset: 4,
    //       },
    //     ],
    //   }
    // }
  }

  let employees = []
  let modifiedScore = []
  let originalScore = []

  dashboardStats &&
    dashboardStats.allEmployees &&
    dashboardStats.allEmployees.forEach((val) => {
      employees.push(val.employee.name)
      modifiedScore.push(val.modifiedAuditScore)
      originalScore.push(val.originalScore)
    })

  const barData = {
    labels: employees,
    datasets: [
      {
        label: 'Modified Score',
        data: modifiedScore,
        backgroundColor: 'rgb(255, 99, 132)',
      },
      {
        label: 'Original Score',
        data: originalScore,
        backgroundColor: 'rgb(54, 162, 235)',
      },
    ],
  }

  return (
    <Layout heading="Dashboard">
      {dashboardData.loading ? (
        <Loader />
      ) : (
        <Grid container>
          <Grid item lg={6}>
            <CardWithChart heading="Tasks">
              <Doughnut data={dougnutData} options={Doughnutdata.DoughnutOptions} />
            </CardWithChart>
          </Grid>
          <Grid item lg={6}>
            <CardWithChart heading="Top 5 Employees">
              <Box display="flex" className={classes.root}>
                {dashboardStats &&
                  dashboardStats.top5 &&
                  dashboardStats.top5.map((val, index) => (
                    <Box display="flex" alignItems="center">
                      <Avatar />
                      <Box marginLeft="15px" marginTop="23px">
                        <Typography>{val.employee.name} </Typography>
                        <Typography>
                          {' '}
                          Modified Score <strong>:{val.modifiedAuditScore} </strong>{' '}
                        </Typography>
                        <Typography>
                          {' '}
                          Total Score : <strong> {val.totalAuditScore} </strong>{' '}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
              </Box>
            </CardWithChart>
          </Grid>
          <Grid item lg={12}>
            <CardWithChart heading="Modified Audit Score VS Original Audit Score">
              <Bar data={barData} options={options} />
            </CardWithChart>
          </Grid>
        </Grid>
      )}
    </Layout>
  )
}
